export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/constants/default-portals-publish.ts"